import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { MymeType, UUID } from '@myme/utils';
import { mq } from 'src/themes';
import { mymeDetailsPageRoute } from 'src/routes/route-list';
import { MymeTypeIcon } from '../bottomPanel/MymeTypeIcon';

interface Props {
  id: UUID;
  previewImage: string;
  type: MymeType;
}

interface StyledMymeImageContainerProps {
  $previewImage: string;
}

const APP_LOGO = '/Logo.png';

const StyledMymeImageContainer = styled.div<StyledMymeImageContainerProps>(
  ({ $previewImage }) => `
    grid-area: photo;
    position: relative;
    width: 8rem;
    height: 8rem;
    background: url(${$previewImage});
    background-size: cover;
    margin-right: 0.5rem;
    border-radius: 1rem;

    ${mq.sm} {
      height: 6rem;
      width: 6rem;
    }

    ${mq.xs} {
      height: 4.5rem;
      width: 4.5rem;
      margin-right: 0;
    }
`
);

const StyledMymeTypeIcon = styled.div`
  position: absolute;
  bottom: 0.25rem;
  right: 0.25rem;
`;

export const MymePreviewImage = ({ id, previewImage, type }: Props) => {
  const navigate = useNavigate();

  return (
    <StyledMymeImageContainer
      onClick={() => navigate(mymeDetailsPageRoute(id))}
      $previewImage={previewImage || APP_LOGO}
    >
      <StyledMymeTypeIcon>
        <MymeTypeIcon type={type} />
      </StyledMymeTypeIcon>
    </StyledMymeImageContainer>
  );
};
